import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import dateUtils from '../../../../../../utils/date-format';
import globalCourseStore from '../../../../../../stores/global-course-store';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const createNewExamOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  name: string,
  examTypeId: number | undefined,
  completionGrade: boolean,
  points: number,
  hide: () => any,
) => {
  try {
    if (isNaN(programId) || isNaN(courseId)) {
      toast.warn('לא ניתן לאתר את מזהה הקורס/תוכנית, נסה שוב בעוד מספר רגעים');
      return;
    }
    if (name.length < 3 || name.length > 40) {
      toast.warn('על שם המטלה להיות בין 3 ל40 תווים');
      return;
    }

    if (!examTypeId) {
      toast.warn('יש לבחור סוג מבחן');
      return;
    }

    if (!completionGrade && (points < 0 || points > 100)) {
      toast.warn('יש לבחור ניקוד בטווח תקין');
      return;
    }

    const examRes = await appApi.addNewExam(
      programId!,
      courseId!,
      name,
      examTypeId,
      completionGrade,
      points,
    );

    if (examRes.data.errCode) {
      toast.warn(displayErrorText(examRes.data.errCode));
      return;
    }

    if (globalCourseStore.getCurrentCourse()?.details) {
      globalCourseStore.getCurrentCourse()!.details!.exams = examRes.data.body;
    }

    toast.success('הפעולה בוצעה בהצלחה');
    hide();
  } catch (e) {
    console.error(`createNewExamOperation is failed with the error: ${e}`);
    toast.error('הפעולה נכשלה, נסה שוב בעוד מספר רגעים');
  }
};
